module.exports = __webpack_public_path__ + "media/images/iconTrendUp__accent--dark-ac7eef33ce260262013d4f2260251eb2.png";